// Current Lodge Actions

import { getCurrentResortData } from '../../../utilities/lodgeData';
import currentLodgeActionTypes from './currentLodge.types';

export const updateCurrentLodge = () => dispatch => {
  dispatch({
    type: currentLodgeActionTypes.UPDATE_CURRENT_LODGE,
    resortLocation: getCurrentResortData()?.resortCode ?? ''
  });
};
